import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AvaamoComponent } from './components/student-support/avaamo/avaamo.component';
import { EnrollmentAgentComponent } from './components/enrollment-agent/enrollment-agent.component';
import { AzureComponent } from './components/student-support/azure/azure.component';
import {  OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { ChatbotComponent } from './components/chatbot/chatbot.component';
import { LogoutCallbackComponent } from './components/logout-callback/logout-callback.component';
const routes: Routes = [
  {path:'', redirectTo:'',pathMatch:'full'},
  {path:'login/callback',component:OktaCallbackComponent},
  {path:'',component:LogoutCallbackComponent},
  {path:'studentbot',component:AvaamoComponent,  canActivate: [OktaAuthGuard],title: 'Student bot'},
  {path:'student-support-azure', component:AzureComponent, canActivate: [OktaAuthGuard], title:'Student support-azure'},
  {path:'enrollmentcopilot', component:EnrollmentAgentComponent,  canActivate: [OktaAuthGuard], title: 'Enrollment Co-pilot'},
  {path: 'chatbot', component: ChatbotComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
